import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import MediaContainer from './mediaSection/MediaContainer';
import DetailsContainer from './detailsSection/DetailsContainer';
import FooterContainer from './footerSection/FooterContainer';
import ShowOffSiteInfo from './ShowOffSiteInfo';
import { addImageParams } from '../../utilities/images';

const VehicleCard = ({
	accounts,
	shouldShowCompare,
	enableMediaCarousel,
	incentives,
	inventoryIndex,
	isGridLayout,
	isMyCarsSitePropEnabled,
	isTabbedLayout,
	setShowOffSite,
	vehicle,
	loadingDelayed,
	forwardedRef,
	featuredPromotion,
	usePlaceholderImage,
	shouldFullyRenderCard,
	enableSSR
}) => {
	const { uuid, link, images } = vehicle;
	// Get 1st vehicle's image as placholder when SSR is enabled
	const preloadPlaceholderImageSrc =
		enableSSR && images[0]?.uri && inventoryIndex === 0
			? addImageParams(images[0].uri)
			: null;
	return (
		<li
			ref={forwardedRef}
			key={uuid}
			className={setClassNames([
				'box',
				'box-border',
				'vehicle-card',
				'vehicle-card-detailed',
				isGridLayout ? null : 'vehicle-card-horizontal',
				setShowOffSite && 'vehicle-card-fade position-relative',
				featuredPromotion && 'vehicle-card-featured',
				vehicle.offSite && 'vehicle-offsite'
			])}
			data-uuid={uuid}
			data-index={inventoryIndex}
		>
			{setShowOffSite && (
				<ShowOffSiteInfo handleClick={() => setShowOffSite(true)} />
			)}
			<div
				className={setClassNames([
					'vehicle-card-body',
					'ddc-font-size-small',
					isGridLayout ? null : 'd-sm-flex', // TODO: deprecate
					isGridLayout ? null : 'flex-sm-row' // TODO: deprecate
				])}
			>
				<MediaContainer
					{...{
						shouldFullyRenderCard,
						enableMediaCarousel,
						isTabbedLayout,
						vehicle,
						loadingDelayed,
						usePlaceholderImage,
						inventoryIndex
					}}
					accountPhone={accounts[vehicle.accountId]?.phone}
					ssrPlaceholderImage={preloadPlaceholderImageSrc}
				/>
				<DetailsContainer
					{...{
						shouldFullyRenderCard,
						vehicle,
						incentives,
						accounts,
						isTabbedLayout,
						isGridLayout
					}}
				/>
			</div>
			<FooterContainer
				{...{
					shouldFullyRenderCard,
					isTabbedLayout,
					shouldShowCompare,
					isMyCarsSitePropEnabled,
					uuid,
					link
				}}
			/>
		</li>
	);
};

const WrappedVehicleCard = React.forwardRef((props, ref) => {
	return <VehicleCard {...props} forwardedRef={ref} />;
});

VehicleCard.propTypes = {
	enableMediaCarousel: PropTypes.bool.isRequired,
	inventoryIndex: PropTypes.number.isRequired,
	isGridLayout: PropTypes.bool.isRequired,
	isMyCarsSitePropEnabled: PropTypes.bool.isRequired,
	isTabbedLayout: PropTypes.bool.isRequired,
	incentives: PropTypes.shape({}).isRequired,
	accounts: PropTypes.shape({}).isRequired,
	vehicle: PropTypes.shape({
		images: PropTypes.arrayOf(
			PropTypes.shape({
				uri: PropTypes.string
			})
		),
		uuid: PropTypes.string,
		link: PropTypes.string,
		accountId: PropTypes.string,
		offSite: PropTypes.bool
	}).isRequired,
	setShowOffSite: PropTypes.func,
	shouldShowCompare: PropTypes.bool.isRequired,
	loadingDelayed: PropTypes.bool.isRequired,
	featuredPromotion: PropTypes.bool,
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	usePlaceholderImage: PropTypes.bool,
	shouldFullyRenderCard: PropTypes.bool,
	enableSSR: PropTypes.bool
};

export default WrappedVehicleCard;
